import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-access-expired',
    templateUrl: './access-expired.component.html',
    styleUrls: ['./access-expired.component.scss'],
    standalone: false
})
export class AccessExpiredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
